import styled from "styled-components"
import { Link } from "react-router-dom"
import {
   mobile,
   smallScreen,
   medScreen,
   tablet,
   mobilePortrait,
} from "../../Responsive"

export const Container = styled.div`
   position: fixed;
   top: 0;
   left: 0;
   width: 100%;
   z-index: 1000;
   min-height: 5vh;
`

export const Wrapper = styled.div`
   padding: 10px 20px;
   display: flex;
   align-items: center;
   justify-content: space-between;
   color: var(--${(props) => props.textColor});

   ${mobile({ padding: "5px 0px" })}
`

export const Left = styled.div`
   flex: 1;
   display: flex;
   flex-wrap: wrap;
   align-items: center;
   justify-content: flex-start;
   max-width: 33%;

   ${mobile({ display: "none" })}
`

export const Language = styled.span`
   margin-left: 10px;
   font-size: var(--fontS);
   font-weight: 600;
   color: var(--lightGrey);
   cursor: pointer;
   transition: 300ms all;

   ${({ selected }) =>
      selected &&
      "color: var(--secondary); font-size: var(--fontM); font-weight: 800;"};
`

export const SearchContainer = styled.div`
   border: 0.5px solid var(--${(props) => props.textColor});
   font-size: var(--fontS);
   display: flex;
   align-items: center;
   padding: 5px;
   margin: 5px 0px;

   ${mobile({ display: "none" })}
`

export const Input = styled.input`
   background-color: transparent;
   color: var(--${(props) => props.textColor});
   border: none;
   width: 70px;
   transition:
      ease-in-out,
      width 0.35s ease-in-out;

   ::placeholder {
      color: var(--${(props) => props.textColor});
   }

   :focus {
      width: 200px;
      outline: none;
   }
`

export const Center = styled.div`
   position: absolute;
   top: 0;
   left: 50%;
   transform: translateX(-50%);
   flex: 1;
   display: flex;
   flex-direction: column;
   justify-content: center;
   text-align: center;
   transition:
      ease-in-out,
      width 0.35s ease-in-out;

   ${({ searchFocus }) => searchFocus && "justify-content: flex-start"};
`

export const Logo = styled.img`
   height: 100px;

   ${tablet({ height: "80px" })}
   ${mobile({ height: "60px" })}
    ${mobilePortrait({ height: "40px" })}
`

export const Right = styled.div`
   flex: 1;
   display: flex;
   align-items: center;
   justify-content: flex-end;

   ${mobile({ marginRight: "10px" })}
`

export const MenuItem = styled.div`
   font-size: var(--fontM);
   cursor: pointer;
   margin-left: 20px;
   display: flex;
   align-items: center;
   justify-content: center;

   @media screen and (max-width: ${medScreen}) {
      font-size: var(--fontS);
   }

   @media screen and (max-width: ${smallScreen}) {
      font-size: var(--fontS);
      margin-left: 10px;
      margin-bottom: 8px;
   }
`

export const StyledLink = styled(Link).withConfig({
   shouldForwardProp: (prop) => prop !== "displayMobile",
})`
   text-decoration: none;
   color: inherit;
   cursor: pointer;
   display: flex;
   align-items: center;
   justify-content: center;
   height: 100%;

   @media screen and (max-width: ${smallScreen}) {
      display: ${(props) => props.displayMobile};
   }
`

export const MenuIconWrapper = styled.div`
   display: none;

   ${mobile({
      display: "flex",
      cursor: "pointer",
      marginLeft: "20px",
   })}
`
export const MenuText = styled.span`
   margin-left: 10px;
   font-size: var(--fontS);
   font-weight: 600;
   cursor: pointer;
`
